module.exports = __webpack_public_path__ + "img/logo-s.bb54fae3.svg";